import styled from 'styled-components';

export const VerticalFormFields = styled.div`
  .ant-form-item-row,
  .ant-form-item > .ant-row {
    flex-direction: column;
  }

  .ant-form-item-label,
  .ant-form-item-control {
    flex: none;
    width: 100%;
    max-width: 100%;
  }

  .ant-form-item-label {
    padding-bottom: 8px;
    text-align: start;
    white-space: normal;

    > label {
      height: auto;

      &::after {
        display: none;
      }
    }
  }

  .ant-row > .ant-col {
    flex: 0 0 100%;
    max-width: 100%;
  }
`;
